import Class from './chart-tone-line';
import './chart-tone-line@';

export default Class;